export const environment = {
  production: true,
  name: 'biib',
  apiUrl: 'https://e948abn59l.execute-api.us-east-1.amazonaws.com/Biib',
  webSocketUrl: 'wss://e7bumotuki.execute-api.us-east-1.amazonaws.com/production/',
  apiUrlImg: 'https://imagenesepsdevbiib.s3.us-east-1.amazonaws.com/',
  featureFlag: true,
  urlPlantilla: 'https://dataexportinphagod.s3.us-east-1.amazonaws.com/Plantilla-Cargue-Masivo-Autorizaciones.xls',
  aws: {
    bucketName: 'autorizacioninphagobiibprod',
    region: 'us-east-1',
    // accessKeyId: 'AKIAXESSBK5KF57UTKGQ',
    // secretAccessKey: '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',
    accessKeyId: '',
    secretAccessKey: '',
    bucketNamePacientes: 'pacientesinphagobiibprod',
    bucketNameRemisiones: 'pdfsoporteremisionbiibprod',
    bucketNameVrFacturas: 'pdfvrfacturasbiibprod',
    bucketNameAutorizaciones: 'pdfsoporteautorizacionbiibprod',
    bucketNameSoporteFactura: 'pdfsoportefacturasbiibprod',
    bucketNameSoporteXml: 'pdfsoportexmlsbiibprod',
    bucketDireccionamiento: 'direccionamientoprodbiib',
    bucketRadicar: 'webpacientesbiibprod',
    bucketRadicarWeb: 'webpacientesbiibprod',
    bucketRadicarApp: 'radicarpacienteprodbiib',
    bucketMedicosPbs: 'medicospbsexcelprodbiib',
    bucketuploadOfAuthorizations: 'cargarautorizacionesprodbiib',
    bucketuploadOfRipsXLSX: 'cargaripsprodbiib',
    bucketuploadOfMipressXLSX: 'cargamipressprodbiib',
    bucketuploadOfMedicosPreXLSX: 'cargamedicospreprodbiib',
    bucketMedicosNoPbs: 'medicosnopbsexcelprodbiib',
    bucketpdfautorizaciones: 'pdfautorizacionesprodbiib',
    bucketcasos: 'casosprodbiib',
    bucketanexosparasubsanar: 'anexosparasubsanarbiibprod',
    bucketImportaciones: 'importacionesbiibprod',
    bucketLogisticaRemision: 'soporteremisionlogisticaprodbiib',
    bucketpdfsoporteaplicacionbiib: 'pdfsoporteaplicacionbiibprod'
  },
  SECRET_KEY: "12221992901234567890PROD20122107",
  INIT_VECTOR: "1205110490132107"
};